import { render, staticRenderFns } from "./add-warning.vue?vue&type=template&id=c0fa2a74&scoped=true"
import script from "./add-warning.vue?vue&type=script&lang=ts"
export * from "./add-warning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fa2a74",
  null
  
)

export default component.exports